<template>
  <el-form ref="paramForm" :model="paramForm" :inline="true" label-width="90px" class="formInline" size="mini"
           :rules="rules">
    <div class="slide-wrap" ref="slideWrap1">
      <el-row>
        <!--其实不用v-for接v-if（只要有一个符合条件则显示），因为后台返回的顺序是固定的，懒得改了-->
        <el-form-item label="姓名" prop="name" v-for="i in paramConfig" :key="i.id" v-if="i.crmMaster.masterName=='姓名'">
          <el-input v-model="paramForm.name" placeholder="请输入..." :maxlength="10"></el-input>
        </el-form-item>
        <el-form-item label="身份证" prop="idcard" v-for="i in paramConfig" :key="i.id"
                      v-if="i.crmMaster.masterName=='身份证'">
          <el-input v-model="paramForm.idcard" placeholder="请输入..." :maxlength="18"></el-input>
        </el-form-item>
        <el-form-item label="促销员ID" prop="empPk" v-for="i in paramConfig" :key="i.id"
                      v-if="i.crmMaster.masterName=='促销员ID'">
          <el-input v-model="paramForm.empPk" placeholder="请输入..." :maxlength="50"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="tel" v-for="i in paramConfig" :key="i.id"
                      v-if="i.crmMaster.masterName=='手机号'">
          <el-input v-model="paramForm.tel" placeholder="请输入..." :maxlength="50"></el-input>
        </el-form-item>
        <el-form-item label="年龄" style="margin-bottom: 0; margin-right:0" v-for="i in paramConfig" :key="i.id"
                      v-if="i.crmMaster.masterName=='年龄'">
          <el-form-item prop="ageMin" style="width:83.5px;margin: 0; padding:0">
            <el-input v-model="paramForm.ageMin" placeholder="岁" class="small-input"></el-input>
          </el-form-item>
          -
          <el-form-item prop="ageMax">
            <el-input v-model="paramForm.ageMax" placeholder="岁" class="small-input"></el-input>
          </el-form-item>
        </el-form-item>
        <el-form-item label="身高" style="margin-bottom: 0; margin-right:0" v-for="i in paramConfig" :key="i.id"
                      v-if="i.crmMaster.masterName=='身高'">
          <el-form-item prop="heightMin" style="width:83.5px;margin: 0; padding:0">
            <el-input v-model="paramForm.heightMin" placeholder="CM" class="small-input"></el-input>
          </el-form-item>
          -
          <el-form-item prop="heightMax">
            <el-input v-model="paramForm.heightMax" placeholder="CM" class="small-input"></el-input>
          </el-form-item>
        </el-form-item>
        <el-form-item label="状态" prop="status" v-for="i in paramConfig" :key="i.id"
                      v-if="i.crmMaster.masterName=='状态' && userIsPLUS">
          <el-select v-model="paramForm.status" placeholder="请选择状态">
            <el-option label="不限" :value="null"></el-option>
            <el-option label="项目中" value="在岗"></el-option>
            <el-option label="待岗中" value="待岗"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="性别" prop="sex" v-for="i in paramConfig" :key="i.id" v-if="i.crmMaster.masterName=='性别'">
          <el-select v-model="paramForm.sex" placeholder="请选择性别">
            <el-option label="不限" :value="null"></el-option>
            <el-option label="男" value="1"></el-option>
            <el-option label="女" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="学历" prop="educationId" v-for="i in paramConfig" :key="i.id"
                      v-if="i.crmMaster.masterName=='学历'">
          <el-select v-model="paramForm.educationId" placeholder="请选择学历">
            <el-option label="不限" :value="null"></el-option>
            <el-option :label="item.masterName" :value="item.id" v-for="item in educationList"
                       :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="信用" style="margin-bottom: 0; margin-right:0" v-for="i in paramConfig" :key="i.id"
                      v-if="i.crmMaster.masterName=='信用' && userIsPLUS">
          <el-form-item prop="creditScoreMin" style="width:83.5px;margin: 0; padding:0">
            <el-input v-model="paramForm.creditScoreMin" placeholder="分数" class="small-input"></el-input>
          </el-form-item>
          -
          <el-form-item prop="creditScoreMax">
            <el-input v-model="paramForm.creditScoreMax" placeholder="分数" class="small-input"></el-input>
          </el-form-item>
        </el-form-item>
        <el-form-item label="星级" prop="starLevelId" v-for="i in paramConfig" :key="i.id"
                      v-if="i.crmMaster.masterName=='星级' && userIsPLUS">
          <el-select v-model="paramForm.starLevelId" placeholder="请选择星级">
            <el-option label="不限" :value="null"></el-option>
            <el-option :label="item.rankName" :value="item.id" v-for="item in starLevelList" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="地区123" prop="provinceId" v-for="i in paramConfig" :key="i.id" v-if="i.crmMaster.masterName=='地区'">
          <el-cascader :options="options" v-model="selectedArea" filterable change-on-select @change="handleChange"></el-cascader>
        </el-form-item> -->
        <el-form-item label="省" prop="provinceId" v-for="i in paramConfig" :key="i.id"
                      v-if="i.crmMaster.masterName=='地区' && userIsPLUS">
          <el-select v-model="paramForm.provinceId" filterable placeholder="请选择省" @change="searchCity">
            <el-option label="不限" :value="null"></el-option>
            <el-option :label="item.adName" :value="item.id" v-for="item in provinceList" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="市" prop="cityId" v-for="i in paramConfig" :key="i.id"
                      v-if="i.crmMaster.masterName=='地区' && userIsPLUS">
          <el-select v-model="paramForm.cityId" filterable placeholder="请选择市" @change="searchArea">
            <el-option label="不限" :value="null"></el-option>
            <el-option :label="item.adName" :value="item.id" v-for="item in cityList" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="地区" prop="areaId" v-for="i in paramConfig" :key="i.id"
                      v-if="i.crmMaster.masterName=='地区' && userIsPLUS">
          <el-select v-model="paramForm.areaId" filterable placeholder="请选择地区">
            <el-option label="不限" :value="null"></el-option>
            <el-option :label="item.adName" :value="item.id" v-for="item in areaList" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否有合约" prop="agreement" v-for="i in paramConfig" :key="i.id"
                      v-if="i.crmMaster.masterName=='是否有合约' && userIsPLUS">
          <el-select v-model="paramForm.agreement" placeholder="请选择是否有合约">
            <el-option label="不限" :value="null"></el-option>
            <el-option label="有" value="1"></el-option>
            <el-option label="没有" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="个人信息授权" prop="authorizeFlag" style="white-space: nowrap"
                      v-if="userIsPLUS && showAuthorizeFlag">
          <el-select v-model="paramForm.authorizeFlag" placeholder="个人信息授权">
            <el-option label="不限" :value="null"></el-option>
            <el-option label="已授权" value="1"></el-option>
            <el-option label="未授权" value="0"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="促销员ID" prop="empPk" v-for="i in paramConfig" :key="i.id"
                      v-if="i.crmMaster.masterName=='促销员ID'">
          <el-input v-model="paramForm.empPk" placeholder="请输入..." :maxlength="50"></el-input>
        </el-form-item> -->
        <el-form-item label="认证状态" prop="isAuthentication" v-for="i in paramConfig" :key="i.id"
                      v-if="i.crmMaster.masterName=='认证状态' && userIsPLUS">
          <el-select v-model="paramForm.isAuthentication" placeholder="请选择认证状态">
            <el-option label="不限" :value="null"></el-option>
            <el-option label="注册会员" value="0"></el-option>
            <el-option label="身份认证" value="1"></el-option>
            <el-option label="实名认证" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="银行卡认证状态" prop="isBankAuthentication" v-for="i in paramConfig" :key="i.id"
                      v-if="i.crmMaster.masterName=='银行卡认证状态' && userIsPLUS">
          <el-select v-model="paramForm.isBankAuthentication" placeholder="请选择银行卡认证状态">
            <el-option label="不限" :value="null"></el-option>
            <el-option label="通过" value="1"></el-option>
            <el-option label="未通过" value="0"></el-option>
            <el-option label="人工认证" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="门店名称" prop="storeName" v-for="i in paramConfig" :key="i.id"
                      v-if="i.crmMaster.masterName=='门店名称'">
          <el-input v-model="paramForm.storeName" placeholder="请输入..." :maxlength="50"></el-input>
        </el-form-item>
        <el-form-item label="门店编码" prop="storeCode" v-for="i in paramConfig" :key="i.id"
                      v-if="i.crmMaster.masterName=='门店编码'">
          <el-input v-model="paramForm.storeCode" placeholder="请输入..." :maxlength="50"></el-input>
        </el-form-item>
        <!-- <el-form-item label="手机号" prop="tel" v-for="i in paramConfig" :key="i.id"
                      v-if="i.crmMaster.masterName=='手机号'">
          <el-input v-model="paramForm.tel" placeholder="请输入..." :maxlength="50"></el-input>
        </el-form-item> -->
        <el-form-item label="是否签约" prop="signContract" v-for="i in paramConfig" :key="i.id"
                      v-if="i.crmMaster.masterName=='否签约薪太软'">
          <el-select v-model="paramForm.signContract" placeholder="请选择...">
            <el-option label="不限" :value="null"></el-option>
            <el-option label="已签约" value="true"></el-option>
            <el-option label="未签约" value="false"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="签约客户" prop="signCustomer" v-for="i in paramConfig" :key="i.id"
                      v-if="i.crmMaster.masterName=='签约客户'">
          <el-select v-model="paramForm.signCustomer" filterable placeholder="请选择...">
            <el-option label="不限" :value="null"></el-option>
            <el-option v-for="item in customerList" :key="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
      </el-row>
      <el-row v-if="userIsPLUS">
        <hr v-if="config_top && config_bottom">
        <el-form-item label="项目数量" style="margin-bottom: 0; margin-right:0" v-for="i in paramConfig" :key="i.id"
                      v-if="i.crmMaster.masterName=='项目数量'">
          <el-form-item prop="projectNumMin" style="width:83.5px;margin: 0; padding:0">
            <el-input v-model="paramForm.projectNumMin" placeholder="个" class="small-input"></el-input>
          </el-form-item>
          -
          <el-form-item prop="projectNumMax">
            <el-input v-model="paramForm.projectNumMax" placeholder="个" class="small-input"></el-input>
          </el-form-item>
        </el-form-item>
        <el-form-item label="服务月数" style="margin-bottom: 0; margin-right:0" v-for="i in paramConfig" :key="i.id"
                      v-if="i.crmMaster.masterName=='服务月数'">
          <el-form-item prop="workMonthMin" style="width:83.5px;margin: 0; padding:0">
            <el-input v-model="paramForm.workMonthMin" placeholder="月" class="small-input"></el-input>
          </el-form-item>
          -
          <el-form-item prop="workMonthMax">
            <el-input v-model="paramForm.workMonthMax" placeholder="月" class="small-input"></el-input>
          </el-form-item>
        </el-form-item>
        <el-form-item label="服务渠道" prop="channel" v-for="i in paramConfig" :key="i.id"
                      v-if="i.crmMaster.masterName=='服务渠道'">
          <el-select v-model="paramForm.channel" placeholder="请选择服务渠道">
            <el-option label="不限" :value="null"></el-option>
            <el-option :label="item.masterName" :value="item.masterName" v-for="item in channelList"
                       :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="场次数量" style="margin-bottom: 0; margin-right:0" v-for="i in paramConfig" :key="i.id"
                      v-if="i.crmMaster.masterName=='场次数量'">
          <el-form-item prop="frequencyNumMin" style="width:83.5px;margin: 0; padding:0">
            <el-input v-model="paramForm.frequencyNumMin" placeholder="场" class="small-input"></el-input>
          </el-form-item>
          -
          <el-form-item prop="frequencyNumMax">
            <el-input v-model="paramForm.frequencyNumMax" placeholder="场" class="small-input"></el-input>
          </el-form-item>
        </el-form-item>

        <el-form-item label="是否QHR人员" prop="qhrStatus" v-for="i in paramConfig" :key="i.id"
                      v-if="i.crmMaster.masterName=='是否QHR人员'" >
          <el-select v-model="paramForm.qhrStatus" placeholder="请选择">
            <el-option label="全部" value="0"></el-option>
            <el-option label="否" value="5"></el-option>
            <el-option label="是" value="6"></el-option>
            <el-option label="在职" value="1"></el-option>
            <el-option label="离职中" value="2"></el-option>
            <el-option label="取消离职" value="3"></el-option>
            <el-option label="离职" value="4"></el-option>
          </el-select>
        </el-form-item>

        <!--180518按需求隐藏此项目，redmine#8118-->

        <!--        <el-form-item label="项目单价" style="margin-bottom: 0; margin-right:0" v-for="i in paramConfig" :key="i.id" v-if="i.crmMaster.id==15">
                  <el-form-item prop="projectPriceMin" style="width:83.5px;margin: 0; padding:0">
                    <el-input v-model="paramForm.projectPriceMin" placeholder="元" class="small-input"></el-input>
                  </el-form-item> -
                  <el-form-item prop="projectPriceMax">
                    <el-input v-model="paramForm.projectPriceMax" placeholder="元" class="small-input"></el-input>
                  </el-form-item>
                </el-form-item>-->
        <filter-tag v-on:signId-Lst="signIdLsts" :postId="postId" v-if="userIsPLUS" ref="filterTag"></filter-tag>
      </el-row>
    </div>
    <hr style="margin-bottom: 9px;">
    <div class="slide-btns clearfix">
      <el-form-item>
        <el-button type="text" class="reset-btn" @click="resetForm('paramForm')">清空</el-button>
        <el-button class="search-btn" @click="submitForm('paramForm', paramForm)">筛选</el-button>
      </el-form-item>
      <div class="floatr">
        <el-form-item>
          <el-button type="text" class="slide-btn" @click="toggleSlide('slideWrap1', $event)">展开筛选项</el-button>
        </el-form-item>
      </div>
    </div>
  </el-form>
</template>

<script>
  import {regionData, CodeToText} from 'element-china-area-data'
  import FilterTag from 'components/filterTag'
  import rules from '../common/js/formRules'
  import utils from '../common/js/util'

  export default {
    components: {
      FilterTag
    },
    watch: {
      'paramForm.ageMin'() {
        this.$refs.paramForm.validateField('ageMax')
      },
      'paramForm.ageMax'() {
        this.$refs.paramForm.validateField('ageMin')
      },
      'paramForm.heightMin'() {
        this.$refs.paramForm.validateField('heightMax')
      },
      'paramForm.heightMax'() {
        this.$refs.paramForm.validateField('heightMin')
      },
      'paramForm.creditScoreMin'() {
        this.$refs.paramForm.validateField('creditScoreMax')
      },
      'paramForm.creditScoreMax'() {
        this.$refs.paramForm.validateField('creditScoreMin')
      },
      'paramForm.projectNumMin'() {
        this.$refs.paramForm.validateField('projectNumMax')
      },
      'paramForm.projectNumMax'() {
        this.$refs.paramForm.validateField('projectNumMin')
      },
      'paramForm.workMonthMin'() {
        this.$refs.paramForm.validateField('workMonthMax')
      },
      'paramForm.workMonthMax'() {
        this.$refs.paramForm.validateField('workMonthMin')
      },
      'paramForm.frequencyNumMin'() {
        this.$refs.paramForm.validateField('frequencyNumMax')
      },
      'paramForm.frequencyNumMax'() {
        this.$refs.paramForm.validateField('frequencyNumMin')
      },
      'paramForm.projectPriceMin'() {
        this.$refs.paramForm.validateField('projectPriceMax')
      },
      'paramForm.projectPriceMax'() {
        this.$refs.paramForm.validateField('projectPriceMin')
      },
    },
    data() {
      var _this = this;
      //年龄-动态关联校验
      var ageMin = (rule, value, callback) => {
        //180622说不要年龄限制了
        rules.rangeMin(value, _this.paramForm.ageMax, callback)
      }
      var ageMax = (rule, value, callback) => {
        //180622说不要年龄限制了
        rules.rangeMax(value, _this.paramForm.ageMin, callback)
      };
      //身高：动态关联校验
      var heightMin = (rule, value, callback) => {
        rules.rangeMin(value, _this.paramForm.heightMax, callback)
      };
      var heightMax = (rule, value, callback) => {
        rules.rangeMax(value, _this.paramForm.heightMin, callback)
      };
      //信用：动态关联校验
      var creditScoreMin = (rule, value, callback) => {
        rules.rangeMin(value, _this.paramForm.creditScoreMax, callback)
      };
      var creditScoreMax = (rule, value, callback) => {
        rules.rangeMax(value, _this.paramForm.creditScoreMin, callback)
      };
      //项目数量：动态关联验证
      var projectNumMin = (rule, value, callback) => {
        rules.rangeMin(value, _this.paramForm.projectNumMax, callback)
      };
      var projectNumMax = (rule, value, callback) => {
        rules.rangeMax(value, _this.paramForm.projectNumMin, callback)
      };
      //服务月数：动态关联验证
      var workMonthMin = (rule, value, callback) => {
        rules.rangeMin(value, _this.paramForm.workMonthMax, callback)
      };
      var workMonthMax = (rule, value, callback) => {
        rules.rangeMax(value, _this.paramForm.workMonthMin, callback)
      };
      //场次数量：动态关联验证
      var frequencyNumMin = (rule, value, callback) => {
        rules.rangeMin(value, _this.paramForm.frequencyNumMax, callback)
      };
      var frequencyNumMax = (rule, value, callback) => {
        rules.rangeMax(value, _this.paramForm.frequencyNumMin, callback)
      };
      //项目单价：动态关联验证，已经用不上了
      var projectPriceMin = (rule, value, callback) => {
        rules.rangeMin(value, _this.paramForm.projectPriceMax, callback)
      };
      var projectPriceMax = (rule, value, callback) => {
        rules.rangeMax(value, _this.paramForm.projectPriceMin, callback)
      };
      var showAuthorizeFlag = false;
      if(this.postId == 0 && this.$route.path.indexOf("baseCenter") != -1) {
        showAuthorizeFlag = true;
      }
      return {
        userIsPLUS: false,//用户是否不是宝洁
        test: [],
        paramForm: {
          name: null,
          idcard: null,
          provinceId: null,
          cityId: null,
          areaId: null,
          sex: null,
          educationId: null,
          status: null,
          starLevelId: null,
          agreement: null,
          channel: null,
          ageMin: null,
          ageMax: null,
          heightMin: null,
          heightMax: null,
          creditScoreMin: null,
          creditScoreMax: null,
          projectNumMin: null,
          projectNumMax: null,
          workMonthMin: null,
          workMonthMax: null,
          frequencyNumMin: null,
          frequencyNumMax: null,
          projectPriceMin: null,
          projectPriceMax: null,
          postId: this.postId,
          authorizeFlag: null,
          empPk: null,
          isAuthentication: null,
          isBankAuthentication: null,
          storeCode: null,
          storeName: null,
          tel: null,
          signContract: null,
          signCustomer: null,
          // qhrStatusName:'0',//是否QHR人员
        },
        paramConfig: [],

        options: regionData,
        selectedArea: [],

        provinceList: [],
        cityList: [],
        areaList: [],
        config_top: false,
        config_bottom: false,
        // 规则
        rules: {
          name: rules.name,
          idcard: rules.idcard,
          ageMin: [
            rules.number,
            {validator: ageMin, trigger: 'change'}
          ],
          ageMax: [
            rules.number,
            {validator: ageMax, trigger: 'change'}
          ],
          heightMin: [
            rules.number,
            {validator: heightMin, trigger: 'change'}
          ],
          heightMax: [
            rules.number,
            {validator: heightMax, trigger: 'change'}
          ],
          creditScoreMin: [
            rules.number,
            {validator: creditScoreMin, trigger: 'change'}
          ],
          creditScoreMax: [
            rules.number,
            {validator: creditScoreMax, trigger: 'change'}
          ],
          projectNumMin: [
            rules.number,
            {validator: projectNumMin, trigger: 'change'}
          ],
          projectNumMax: [
            rules.number,
            {validator: projectNumMax, trigger: 'change'}
          ],
          workMonthMin: [
            rules.number,
            {validator: workMonthMin, trigger: 'change'}
          ],
          workMonthMax: [
            rules.number,
            {validator: workMonthMax, trigger: 'change'}
          ],
          frequencyNumMin: [
            rules.number,
            {validator: frequencyNumMin, trigger: 'change'}
          ],
          frequencyNumMax: [
            rules.number,
            {validator: frequencyNumMax, trigger: 'change'}
          ],
          projectPriceMin: [
            rules.number,
            {validator: projectPriceMin, trigger: 'change'}
          ],
          projectPriceMax: [
            rules.number,
            {validator: projectPriceMax, trigger: 'change'}
          ],
        },
        // 是否展示个人信息授权的选项
        showAuthorizeFlag: showAuthorizeFlag,
        customerList: []
      }
    },
    props: ['webId', 'postId', 'educationList', 'starLevelList', 'channelList'],
    mounted(){//每次都能触发
      //挂载后才能找到refs
      this.$refs['paramForm'].resetFields()
      this.userIsPLUS = Boolean(sessionStorage.getItem('user'))
      if (this.userIsPLUS) {
        this.searchProvince()
        this.searchCity()
        this.searchArea()
        this.searchAllCustomer()
      }
    },
    created() {//同样每次都能触发
      // 获取筛选项配置
      this.$http({
        method: 'POST',
        url: '/rest/webCondition/getWebCondition',
        params: {
          webId: this.webId,//1是促销员库，2是基础中心
          postId: this.postId//0是全部人员，1是筛选长促，2是筛选短促
        }
      }).then(res => {
        // console.log('筛选项',res.data)
        this.paramConfig = res.data
        res.data.forEach((item) => {
          if (item.crmMaster.id < 11 || item.crmMaster.id > 15) {
            this.config_top = true
          }
        })
        res.data.forEach((item) => {
          if (item.crmMaster.id > 10 && item.crmMaster.id < 16) {
            this.config_bottom = true
          }
        })
      }).catch(err => {
        utils.myNotify(this,'error',err.response,'查询失败，请稍后重试')
      })
    },
    methods: {
      signIdLsts(ids) {
        this.signIdLst = ids
      },
      submitForm(formName, data) {
        data = Object.assign(data, {signIdLst: this.signIdLst})
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.$emit('filterParam', data)
          } else {
            utils.myNotify(this,'warning','筛选项有误，请核对')
            return false;
          }
        })
      },
      //重置表单，调用el-form中方法
      resetForm(formName) {
        // 需要指定form-item的prop
        this.searchProvince();
        this.searchCity();
        this.searchArea();
        this.$refs[formName].resetFields();
        this.$refs['filterTag'].reset();
      },
      //展开和收起筛选框
      toggleSlide(slideWrap, event) {
        if (this.$refs[slideWrap].offsetHeight === 42) {
          this.$refs[slideWrap].style.height = 'auto'
          event.target.innerHTML = '收起筛选项'
        } else {
          this.$refs[slideWrap].style.height = '42px'
          event.target.innerHTML = '展开筛选项'
        }

      },

      searchProvince(id) {
        this.$http({
          method: 'GET',
          url: '/rest/sysUser/getVisualRegionLst',
          params: {
            deep: 1,
            regionId: id
          }
        }).then(res => {
          this.provinceList = res.data
        }).catch(err => {
          utils.myNotify(this,'error',err.response,'查询失败，请稍后重试')
        })
      },
      searchCity(id) {
        this.paramForm.cityId = null
        this.paramForm.areaId = null
        this.$http({
          method: 'GET',
          url: '/rest/sysUser/getVisualRegionLst',
          params: {
            deep: 2,
            regionId: id
          }
        }).then(res => {

          res.data.map(item => {
            if (item.adCode == "31020000") {
              item.adName = '上海市-县'
            } else if (item.adCode == "11020000") {
              item.adName = '北京市-县'
            } else if (item.adCode == '50020000') {
              item.adName = '重庆-县'
            } else if (item.adCode == '12020000') {
              item.adName = '天津-县'
            }
          })
          this.cityList = res.data
        }).catch(err => {
          utils.myNotify(this,'error',err.response,'查询失败，请稍后重试')
        })
      },
      searchArea(id) {
        this.paramForm.areaId = null
        this.$http({
          method: 'GET',
          url: '/rest/sysUser/getVisualRegionLst',
          params: {
            deep: 3,
            regionId: id
          }
        }).then(res => {
          this.areaList = res.data
        }).catch(err => {
          utils.myNotify(this,'error',err.response,'查询失败，请稍后重试')
        })
      },
      handleChange(value) {

      },
      searchAllCustomer() {
        this.$http({
          method: 'GET',
          url: '/rest/baseCenter/all-customers'
        }).then(res => {
          this.customerList = res.data.data
        }).catch(err => {
          utils.myNotify(this,'error',err.response,'查询失败，请稍后重试')
        })
      }
    }
  }
</script>
<style lang="scss" scoped>
  .reset-btn {
    margin-right: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/components/filterParam.vue